



























import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import "./paginator.less";

@Component
export default class Paginator extends Vue {
  @(Prop()!) pagesCnt;
  @(Prop()!) selectedPage;

  get pageNumbers() {
    if (this.pagesCnt < 8) {
      return [...Array(this.pagesCnt).keys()].map(el => el + 1);
    }
    if (this.selectedPage < 4) {
      return [1, 2, 3, 4, "...", this.pagesCnt];
    }
    if (this.selectedPage > this.pagesCnt - 3) {
      return [
        1,
        "...",
        this.pagesCnt - 3,
        this.pagesCnt - 2,
        this.pagesCnt - 1,
        this.pagesCnt
      ];
    }
    return [
      1,
      "...",
      this.selectedPage - 1,
      this.selectedPage,
      this.selectedPage + 1,
      "...",
      this.pagesCnt
    ];
  }

  @Emit("pageSelected")
  private select(pageNum) {}
}
